import { render, staticRenderFns } from "./closing-preview.vue?vue&type=template&id=5c8f521f&"
import script from "./closing-preview.vue?vue&type=script&lang=js&"
export * from "./closing-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports